export default __webpack_public_path__ + "static/media/image05.e8a40325.jpg";